<template>
	<div class="chatPage">		
		<card class="chatWrapper">
			<ReChatWrapper :bIsActiveLeft="bIsActiveLeft" :bIsSwitch="true"/>
		</card>
	</div>
</template>

<script>
import ReChatWrapper from "src/our_components/ReChatWrapper.vue";

export default {
	name: 'chat-page',
	components: {
		ReChatWrapper,
	},
	data() {
		return {
			ApiData: {},
			bIsActiveLeft: true,
		};
	},
	methods: {
		getApiData(){
			this.$GVO.ApiCall('GET',{obj:'template'})
			.then((objApi) => {
				if(objApi.success === true){
				if(objApi.data.length > 0){
					this.ApiData = objApi.data;
				}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
	},
	mounted() {
		this.getApiData();
	}
};
</script>

<style scoped>

</style>
